export default __webpack_public_path__ + "static/media/shapes-bishopHat.04fa958d.png";